import { handleError } from "../util";
import { normalizeError } from "../util/error";
import ErrorPageService from "./errorPageService";
export default class ErrorService extends ErrorPageService {
    show(props) {
        var _a;
        this._props = Object.assign({ hasError: true }, props);
        if (props && props.error) {
            if ("response" in props.error && ((_a = props.error.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
                const normalizedError = normalizeError({ error: props.error });
                this._props = Object.assign(Object.assign({ hasError: true, buttons: ["goBack"] }, props), { error: normalizedError, message: normalizedError.message, title: normalizedError.title });
                this.notify("show");
                throw props.error;
            }
            else {
                handleError({
                    error: props.error,
                    defaultError: "Произошла неизвестная ошибка",
                });
                return;
            }
        }
        this.notify("show");
    }
}
export const errorService = new ErrorService();
//# sourceMappingURL=errorService.js.map